export const theme_ns: ThemeNS = 'campaign';


